/**
 * Created by Administrator on 2018/2/8.
 */
import Vue from "vue";
import Vuex from "vuex";

import navigation from "./modules/navigation";
import listInfo from "./modules/list-info";
import situation from "./modules/situation.js";
import table from "./modules/table.js";
import push from "./modules/push"
import permission from './modules/permission'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    nav: navigation,
    listInfo,
    situation,
    table,
    push,
    permission
  }
})



// WEBPACK FOOTER //
// ./src/managers/vuex/store.js